import React from 'react';
import { QuickReply } from '../types';

interface QuickReplyButtonProps {
  reply: QuickReply;
  onClick: (text: string) => void;
}

const QuickReplyButton: React.FC<QuickReplyButtonProps> = ({ reply, onClick }) => {
  const colorClasses: Record<string, string> = {
    blue: 'bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white',
    red: 'bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700 text-white',
    purple: 'bg-gradient-to-r from-purple-500 to-purple-600 hover:from-purple-600 hover:to-purple-700 text-white',
    green: 'bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white',
    yellow: 'bg-gradient-to-r from-yellow-500 to-yellow-600 hover:from-yellow-600 hover:to-yellow-700 text-white',
    pink: 'bg-gradient-to-r from-pink-500 to-pink-600 hover:from-pink-600 hover:to-pink-700 text-white',
    indigo: 'bg-gradient-to-r from-indigo-500 to-indigo-600 hover:from-indigo-600 hover:to-indigo-700 text-white',
    teal: 'bg-gradient-to-r from-teal-500 to-teal-600 hover:from-teal-600 hover:to-teal-700 text-white',
  };
  
  const colorClass = colorClasses[reply.color] || colorClasses.blue;
  
  return (
    <button
      className={`${colorClass} py-2.5 px-4 rounded-full text-sm font-medium transition-all transform hover:scale-105 active:scale-95 shadow-md hover:shadow-lg`}
      onClick={() => onClick(reply.text)}
    >
      {reply.text}
    </button>
  );
};

export default QuickReplyButton;